import { render, staticRenderFns } from "./Sound.vue?vue&type=template&id=3ce6acc7&scoped=true&lang=html"
import script from "./Sound.vue?vue&type=script&lang=js"
export * from "./Sound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce6acc7",
  null
  
)

export default component.exports